import React from "react";
import PlayerAssetAddEditPage from "./PlayerAssetAddEditPage";
import { PLAYER_ASSET_TYPES } from "../../../constants/playerAssetTypes";

const PlayerMusicAddEditPage = () => <PlayerAssetAddEditPage config={PLAYER_ASSET_TYPES.background_music} />;

export default PlayerMusicAddEditPage;
